import { inputsContext } from '@/reports/inputs';
import { InputsReportContext, RunReportContext } from '@/reports/types';
import { CompiledReportBundle } from './types';

const isObject = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);

/** The context, values and raw settings a fixture gives, read as the server's compile reads them. Throws on one it cannot read. */
export function fixtureInput(compiled: CompiledReportBundle, file: string, json: string): { context: RunReportContext | InputsReportContext; values: unknown; settings: unknown } {
  let fixture: unknown;
  try {
    fixture = JSON.parse(json);
  } catch (error) {
    throw new Error(`${file} is not valid JSON: ${error instanceof Error ? error.message : String(error)}`);
  }
  if (!isObject(fixture)) throw new Error(`${file} is not a JSON object`);
  if (compiled.subject === 'inputs' && compiled.sheet) {
    return { context: inputsContext(compiled.sheet, fixture.inputs ?? {}, fixture.traces), values: fixture.values, settings: fixture.settings };
  }
  if (!isObject(fixture.context) || !isObject(fixture.context.run)) throw new Error(`${file} needs context.run: a run snapshot`);
  const context = { ...fixture.context, project: fixture.context.project ?? null, traces: fixture.context.traces ?? {} } as unknown as RunReportContext;
  return { context, values: fixture.values, settings: fixture.settings ?? context.settings };
}
